import React from 'react';
import '../template-file-css/document-file-template.css';


export const LHH_IncidentReport = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LHH_IncidentReport' className='file-pdf-document'>

            <div className='file-template'>

                <p className='w-750'><center> <h2>LILLY PAD HOME HEALTH, LLC<h4>
                    ACCIDENT AND CRITICAL INCIDENT REPORT FORM
                </h4><small>*Please print clearly - only one form per client - not part of client's record.</small></h2></center>
                </p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Agency Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Site:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtAgencyName' name='txtAgencyName' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtSite' name='txtSite' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>Date:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Time:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Total # of Staff on Duty:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'> <input type='date' id='txtLillyDate' name='txtLillyDate' className='add-only' /> </td>
                        <td className='w-250'> <input type='time' id='txtLillyTime' name='txtLillyTime' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtStaffOnDuty' name='txtStaffOnDuty' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <span className='eleHeader'>Consumer Name &/or ID #:</span>
                            <span className='small'>(As applicable to area program criteria)</span> </td>
                        <td className='w-300'> <span className='eleHeader'># of Cunsumers Involved</span> </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <input type='text' id='txtConsumerName' name='txtConsumerName' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtCunsumersInvolved' name='txtCunsumersInvolved' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <span className='eleHeader'>Supervisor</span></td>
                        <td className='w-300'> <span className='eleHeader'>Assigned CM/QP/Therapist</span> </td>
                    </tr>
                    <tr>
                        <td className='w-450'> <input type='text' id='txtSupervisor' name='txtSupervisor' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtTherapist' name='txtTherapist' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Staff/Other Witnesses </span>
                    <input type='text' id='txtStaffWitnesses' name='txtStaffWitnesses' className='add-only' />
                </p>
                <p className='w-750'> <span className='eleHeader'>Staff Completing Form (Please Print) </span>
                    <input type='text' id='txtStaffCompletingForm' name='txtStaffCompletingForm' className='add-only' />
                </p>

                <p className='w-750'><b>Consumer Information:</b>All Diagnoses According to DSM Criteria</p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Axis I</span></td>
                        <td className='w-375'> <span className='eleHeader'>Axis II</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtAxis_1' name='txtAxis_1' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtAxis_2' name='txtAxis_2' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Axis III</span></td>
                        <td className='w-375'> <span className='eleHeader'>Axis IV</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtAxis_3' name='txtAxis_3' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtAxis_4' name='txtAxis_4' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Check all that apply: (services received from Mental Health) </span>
                </p>
                <table>
                    <tr>
                        <td className='w-100'>
                            <input type='checkbox' id='cbMentalHealth_1' name='cbMentalHealth_1' className='add-only' value='MR/MI' /> MR/MI </td>
                        <td className='w-100'>
                            <input type='checkbox' id='cbMentalHealth_2' name='cbMentalHealth_2' className='add-only' value='CAP' /> CAP </td>
                        <td className='w-100'>
                            <input type='checkbox' id='cbMentalHealth_3' name='cbMentalHealth_3' className='add-only' value='Child' /> Child
                        </td>
                        <td className='w-100'>
                            <input type='checkbox' id='cbMentalHealth_4' name='cbMentalHealth_4' className='add-only' value='Adult' /> Adult </td>
                        <td className='w-100'>
                            <input type='checkbox' id='cbMentalHealth_5' name='cbMentalHealth_5' className='add-only' value='MH' /> MH </td>
                        <td className='w-100'>
                            <input type='checkbox' id='cbMentalHealth_6' name='cbMentalHealth_6' className='add-only' value='DD' /> DD
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbMentalHealth_7' name='cbMentalHealth_7' className='add-only' value='SA' /> SA
                        </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>If incident did not occur on site, explain where </span>
                    <input type='text' id='txtExplainWhere' name='txtExplainWhere' className='add-only' />
                </p>

                <p className='w-750'> <span className='eleHeader'>Did the incident result in hospitalization or emergency room treatment? </span>
                    <input type='radio' id='rbRoomTreatment_Yes' name='rbRoomTreatment' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbRoomTreatment_No' name='rbRoomTreatment' className='add-only' value='No' /> No
                </p>

                <p className='w-750'><b>CATEGORY I.</b></p>
                <p className='w-750'> <span className='eleHeader'>Injury to Persons </span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAccident' name='cbAccident' className='add-only' value='Accident' /> Accident </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAggression' name='cbAggression' className='add-only' value='Aggression' /> Aggression (Physical or verbal) </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMedical' name='cbMedical' className='add-only' value='Medical' /> Medical/Psychiatric Emergency
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDiscovery' name='cbDiscovery' className='add-only' value='Discovery of Mark' /> Discovery of Mark(s) Or Abrasion(s) </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbHomicideOrAttempt' name='cbHomicideOrAttempt' className='add-only' value='Homicide or Attempt' /> Homicide or Attempt </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbInjury' name='cbInjury' className='add-only' value='Injury' /> Injury
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbLifeThreateningInjury' name='cbLifeThreateningInjury' className='add-only' value='Life Threatening Injury' /> Life Threatening Injury
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSuicideAttempt' name='cbSuicideAttempt' className='add-only' value='Suicide Attempt' /> Suicide Attempt
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSeizureCausing' name='cbSeizureCausing' className='add-only' value='Seizure Causing' /> Seizure Causing an Incident
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSelfAbuse' name='cbSelfAbuse' className='add-only' value='Self Abuse' /> Self Abuse
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSeveredBodyParts' name='cbSeveredBodyParts' className='add-only' value='Severed Body Parts' /> Severed Body Parts/Permanent Disability
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSexualAssault' name='cbSexualAssault' className='add-only' value='Sexual Assault' /> Sexual Assault
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPossibleExposure' name='cbPossibleExposure' className='add-only' value='Possible Exposure' /> Possible Exposure to Blood Borne Pathogens (HBV/HIV, etc.)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbInjuryOtherPage' name='cbInjuryOtherPage' className='add-only' value='Other:see page 3' /> Other:see page 3 <br />
                            <input type='text' id='txtInjuryOtherPage' name='txtInjuryOtherPage' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><b>CATEGORY II.</b></p>
                <p className='w-750'> <span className='eleHeader'>Property Damage/Loss </span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAttemptedFire' name='cbAttemptedFire' className='add-only' value='Attempted Fire' /> Attempted Fire Setting </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAutoAccident' name='cbAutoAccident' className='add-only' value='Auto Accident' /> Auto Accident </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbBombThreats' name='cbBombThreats' className='add-only' value='Bomb Threats' /> Bomb Threats
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbFire' name='cbFire' className='add-only' value='Fire' /> Fire </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPropertyDestruction' name='cbPropertyDestruction' className='add-only' value='Property Destruction' /> Property Destruction </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTheftOrBurglary' name='cbTheftOrBurglary' className='add-only' value='Theft or Burglary' /> Theft or Burglary
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbVehicleDamage' name='cbVehicleDamage' className='add-only' value='Vehicle Damage' /> Vehicle Damage/Vandalism
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPropertyOther' name='cbPropertyOther' className='add-only' value='Other:see page 3' /> Other:see page 3 <br />
                            <input type='text' id='txtPropertyOther' name='txtPropertyOther' className='add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'><b>CATEGORY III.</b></p>
                <p className='w-750'> <span className='eleHeader'>Clinical Exceptions </span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPrescribedMedical' name='cbPrescribedMedical' className='add-only' value='Prescribed Medical' /> Against Prescribed Medical Advice/Order </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMedicationError' name='cbMedicationError' className='add-only' value='Medication Error' /> Medication Error </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAdverseEffects' name='cbAdverseEffects' className='add-only' value='Adverse Effects' /> Medication Error With Adverse Effects/Possible
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMissedMedications' name='cbMissedMedications' className='add-only' value='Missed Medications' /> Missed Medications </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbClinicalOther' name='cbClinicalOther' className='add-only' value='Other:see page 3' /> Other:see page 3 <br />
                            <input type='text' id='txtClinicalOther' name='txtClinicalOther' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><b>CATEGORY IV.</b></p>
                <p className='w-750'> <span className='eleHeader'>Risk Management</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbThreatsToSelf' name='cbThreatsToSelf' className='add-only' value='Threats to Self' /> Threats to Self/Others </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDrugRelated' name='cbDrugRelated' className='add-only' value='Drug Related' /> Drug Related (Controlled Substance Abuse, DUI) </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbElopement' name='cbElopement' className='add-only' value='Elopement' />Elopement
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbLawViolations' name='cbLawViolations' className='add-only' value='Law Violations' /> Law Violations- Client </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbLossOfPrivilege' name='cbLossOfPrivilege' className='add-only' value='Loss of Privilege' /> Loss of Privilege </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbObservedTimeAway' name='cbObservedTimeAway' className='add-only' value='Observed Time Away' /> Observed Time Away </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbRestrictiveIntervention' name='cbRestrictiveIntervention' className='add-only' value='Restrictive Intervention' /> Restrictive Intervention </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSafetyIssues' name='cbSafetyIssues' className='add-only' value='Safety Issues' /> Safety Issues </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSearchSeizure' name='cbSearchSeizure' className='add-only' value='Search & Seizure' /> Search & Seizure </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbSecurityIssues' name='cbSecurityIssues' className='add-only' value='Security Issues' /> Security Issues </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAllegedNeglect' name='cbAllegedNeglect' className='add-only' value='Alleged Neglect' /> Alleged Neglect, Alleged Abuse, Exploitation, Violation of Cunsumer Rights </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbClinicalOtherPage' name='cbClinicalOtherPage' className='add-only' value='Other:see page 3' /> Other:see page 3 <br />
                            <input type='text' id='txtClinicalOtherPage' name='txtClinicalOtherPage' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><b>In cases of Death, incident reports MUST BE SUBMITTED IMMEDIATELY...</b></p>

                <table>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Report Submitted:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Date Submitted:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtReportSubmitted' name='txtReportSubmitted' className='add-only' /> </td>
                        <td className='w-375'> <input type='date' id='txtDateSubmitted' name='txtDateSubmitted' className='add-only' /> </td>
                    </tr>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Submitted To:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Who Reported:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='text' id='txtSubmittedTo' name='txtSubmittedTo' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtWhoReported' name='txtWhoReported' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'><b>Description of Injury/Incident:</b>Indicate on figure any bruises, cuts, scratches, marks, etc. as soon as discovered.
                </p>

                <p className='w-750'> <span className='eleHeader'>Injured Person</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbPerson_Consumer' name='rbPerson' className='add-only' value='Consumer' /> Consumer &nbsp;
                            <input type='radio' id='rbPerson_Male' name='rbPerson' className='add-only' value='Male' /> Male &nbsp;
                            <input type='radio' id='rbPerson_Female' name='rbPerson' className='add-only' value='Female' /> Female </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbPerson_Other' name='rbPerson' className='add-only' value='Other' /> Other <br />
                            <input type='text' id='txtPersonOther' name='txtPersonOther' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'> <span className='eleHeader'>Type of Injury</span>
                </p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbScratch' name='cbScratch' className='add-only' value='Scratch' /> Scratch </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBite' name='cbBite' className='add-only' value='Bite' /> Bite </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbLaceration' name='cbLaceration' className='add-only' value='Laceration' /> Laceration
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBrokenBone' name='cbBrokenBone' className='add-only' value='Broken Bone' /> Broken Bone </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBruise' name='cbBruise' className='add-only' value='Bruise' /> Bruise </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSwelling' name='cbSwelling' className='add-only' value='Swelling' /> Swelling
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbInjuryOther_1' name='cbInjuryOther_1' className='add-only' value='Other' /> Other <br />
                            <input type='text' id='txtInjuryOther_1' name='txtInjuryOther_1' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>Use red ink to mark on figures any bruises, cuts, scratches, marks, etc. as soon as discovered.</p>

                <table>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Date: </td>
                        <td className='small w-250'> Signature: </td>
                        <td className='small w-250'> Title: </td>
                    </tr>
                    <tr>
                        <td className='signature w-350'>&nbsp; </td>
                        <td className='signature w-200'>&nbsp; </td>
                        <td className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-450'> Medical Personnel Contacted by
                            <span className='small'>(Document the name of the person contacted)</span>
                        </td>
                        <td className='small w-100'> Time: </td>
                        <td className='small w-200'> Date: </td>
                    </tr>
                </table>

                <p className='w-750'><center><h4>FOLLOW-UP</h4><small>(To be completed every hour for 8 hours)</small></center>
                </p>

                <table>
                    <tr>
                        <td className='w-150'> <span className='eleHeader'>DATE</span> </td>
                        <td className='w-150'> <span className='eleHeader'>TIME</span> </td>
                        <td className='w-300'> <span className='eleHeader'>ASSESSMENT/TREATMENT</span> </td>
                        <td className='w-150'> <span className='eleHeader'>STAFF SIGNATURE</span> </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='txtdate_1' name='txtdate_1' className='add-only' /> </td>
                        <td className='w-150'> <input type='time' id='txtTime_1' name='txtTime_1' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtAssessment_1' name='txtAssessment_1' className='add-only' /> </td>
                        <td className='signature w-150'> &nbsp;  </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='txtdate_2' name='txtdate_2' className='add-only' /> </td>
                        <td className='w-150'> <input type='time' id='txtTime_2' name='txtTime_2' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtAssessment_2' name='txtAssessment_2' className='add-only' /> </td>
                        <td className='signature w-150'>  &nbsp;  </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='txtdate_3' name='txtdate_3' className='add-only' /> </td>
                        <td className='w-150'> <input type='time' id='txtTime_3' name='txtTime_3' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtAssessment_3' name='txtAssessment_3' className='add-only' /> </td>
                        <td className='signature w-150'>  &nbsp;  </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='txtdate_4' name='txtdate_4' className='add-only' /> </td>
                        <td className='w-150'> <input type='time' id='txtTime_4' name='txtTime_4' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtAssessment_4' name='txtAssessment_4' className='add-only' /> </td>
                        <td className='signature w-150'>  &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='txtdate_5' name='txtdate_5' className='add-only' /> </td>
                        <td className='w-150'> <input type='time' id='txtTime_5' name='txtTime_5' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtAssessment_5' name='txtAssessment_5' className='add-only' /> </td>
                        <td className='signature w-150'>  &nbsp;  </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='txtdate_6' name='txtdate_6' className='add-only' /> </td>
                        <td className='w-150'> <input type='time' id='txtTime_6' name='txtTime_6' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtAssessment_6' name='txtAssessment_6' className='add-only' /> </td>
                        <td className='signature w-150'>  &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='txtdate_7' name='txtdate_7' className='add-only' /> </td>
                        <td className='w-150'> <input type='time' id='txtTime_7' name='txtTime_7' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtAssessment_7' name='txtAssessment_7' className='add-only' /> </td>
                        <td className='signature w-150'> &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='txtdate_8' name='txtdate_8' className='add-only' /> </td>
                        <td className='w-150'> <input type='time' id='txtTime_8' name='txtTime_8' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtAssessment_8' name='txtAssessment_8' className='add-only' /> </td>
                        <td className='signature w-150'>  &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='txtdate_9' name='txtdate_9' className='add-only' /> </td>
                        <td className='w-150'> <input type='time' id='txtTime_9' name='txtTime_9' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtAssessment_9' name='txtAssessment_9' className='add-only' /> </td>
                        <td className='signature w-150'>  &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='txtdate_10' name='txtdate_10' className='add-only' /> </td>
                        <td className='w-150'> <input type='time' id='txtTime_10' name='txtTime_10' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtAssessment_10' name='txtAssessment_10' className='add-only' /> </td>
                        <td className='signature w-150'>  &nbsp;  </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='txtdate_11' name='txtdate_11' className='add-only' /> </td>
                        <td className='w-150'> <input type='time' id='txtTime_11' name='txtTime_11' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtAssessment_11' name='txtAssessment_11' className='add-only' /> </td>
                        <td className='signature w-150'>  &nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-150'> <input type='date' id='txtdate_12' name='txtdate_12' className='add-only' /> </td>
                        <td className='w-150'> <input type='time' id='txtTime_12' name='txtTime_12' className='add-only' /> </td>
                        <td className='w-300'> <input type='text' id='txtAssessment_12' name='txtAssessment_12' className='add-only' /> </td>
                        <td className='signature w-150'>  &nbsp;  </td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Date: </td>
                        <td className='small w-250'> Signature: </td>
                        <td className='small w-250'> Title: </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'> DESCRIPTION OF INCIDENT /ACCIDENT and/or OCCURRENCES</span>
                    Narrative: Describe the specific events leading to the Incident/Accident and/or Occurrences. What interventions were taken in addressing situation? Identify other consumers in the report by using A,B,C, etc ONLY.

                    <textarea id='txtNarrative' name='txtNarrative' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'> Date: </td>
                        <td className='small w-250'> Signature: </td>
                        <td className='small w-250'> Title: </td>
                    </tr>
                </table>

            </div>
        </form >

    )
}

